/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {LOADER_STATUS,PROFILE_INFO,DATA_FETCH_INFO,ON_NOTIFY,SET_CHART_2,SET_CHART_3,SET_CHART_4,SET_CHART_5,SET_CHART_6,SET_CHART_7,SET_CHART_8} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData:[],
  dataFetchData: [],
  status: false,
  msg: '',

};

/* eslint-disable default-case, no-param-reassign */
const dataFetchHomeReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case DATA_FETCH_INFO:
        return {
          ...state,
          dataFetchData:action.dataFetchData
        }
      case ON_NOTIFY:
        return {
          ...state,
          status:action.status,
          msg:action.msg
        }
      default:
        return state;
    }
  };

export default dataFetchHomeReducer;
